<div class="white_round padding_sides16">
    <div class='ps-item' *ngFor="let iBrand of manufacturers" (click)="onManufacturerSelected(iBrand)">
    <div class='ps-icon'><img src='{{iBrand.logo}}' alt="{{iBrand.name}}"/></div>
    <div class='ps-arrow' [inlineSVG]="'assets/images/forward.svg'"></div>
</div>